
/**
 * 		Search UI header logic
 *
 * 		@author Irina Patrikeeva <irina.i.patrikeeva@nasa.gov>
 *
 *     	Created on 03/28/2018
 *     	Modified on 06/16/2020
 */

/*jshint strict:false */
/*global Backbone, $, App */

/**
 *  Initialize the header.
 *  @param {string} appName - application name on the left-hand side. If null, set the name to "EVA"
 */
function setHeader( appName ) {

    // loads hideBP from URL parameters
    const queryString = window.location.search;                   // ===== testing
    const urlParams = new URLSearchParams(queryString);

    // returns if header is to be hidden
    var hideBP = urlParams.get('hideBP');                   // ===== testing
    if ( hideBP == 'yes' ) {
        return;
    };

    // TODO:LLD
    if (sharedStylesGlobals && sharedStylesGlobals.utils) {
        sharedStylesGlobals.utils.setAppTitle(appName)
    }

    var headerParentId = App.globalState.headerParentId,
        observer,
        config,
        target,
        header,
        domain;

    // Listen for DOM mutation events and trigger additional header styling when element was inserted
    observer = getMutationObserver('header', styleHeader);
    config = {
        attributes: false,
        childList: true,
        characterData: false
    };
    target = document.getElementById(App.globalState.headerParentId);
    observer.observe(target, config);

    // Detach existing header element if it exists from a different page
    header = $('.header');
    header.remove();

    // Get global application domain name from the shared styles domain config
    if ( sharedStylesGlobals ) {
        var domainConfig = sharedStylesGlobals.domain;
        if ( domainConfig ) {
            domain = domainConfig.SiteName;
            if ( window && window.document ) {
                window.document.title = domain;
            }
        }
    }

    // Call the shared styles to create the header
    // Shared JavaScript file is in /var/www/static/js/edi-styles.js
    if ( ! App.globalState.isDev && typeof ediHeader !== "undefined" ) {
        ediHeader( headerParentId, appName );
    }

    setFooter();
}

/**
 * Style header depending on the page and listen for events
 */
function styleHeader() {
    var header = $('.header'),
        searchBar = header.find('.search-bar');

    // Style header
    searchBar.css('display', 'block');

    // Add event listeners to header search bar
    basicSearch();

    // If global query variable is not empty, set query in the search bar
    $('input[name="basic-search"]').val(App.globalState.query);


    // Hide advanced search header search bar
    if ( Backbone.history.getFragment() === "advanced-search" ) {
        searchBar.css('display', 'none');
    }
}

/**
 * Set single record viewer header
 * @param type {string} - type of the record
 */
function setRecordHeader( type ) {
    if ( type === "part" || type === "emupart") {
        setHeader( "Part Viewer" );
    } else if ( type === "component" || type === "emucomponent") {
        setHeader( "Component Viewer" );
    } else {
        // Default record viewer name
        setHeader( "Record Viewer" );
    }
}

